<!--*
*   Copyright (C) Cylergie - All Rights Reserved
* Proprietary and confidential
* Subject to French law on copyright
* Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
* Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
* Written in 2024 
* -->

<template>
  <v-app v-if="error">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <div class="text-md-center">
          <h1>{{ error_code }}</h1>
          <h3 class="my-3 headline">{{ error_message }}</h3>
        </div>
      </v-layout>
    </v-container>
  </v-app>
  <div v-else class="callback-loading">
    <p>Authentification en cours...</p>
  </div>
</template>

<script>
import { useAuth } from '@okta/okta-vue';
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';

export default {
  name: 'ImplicitCallback',
  setup() {
    const $auth = useAuth();
    const router = useRouter();

    const error_code = ref(null);
    const error_message = ref('');
    const error = ref(false);

    onMounted(async () => {
      try {
        // Handle the callback from Okta
        await $auth.handleLoginRedirect();
        // Redirect to the original URL or home
        const originalUri = $auth.getOriginalUri();
        router.replace(originalUri || '/');
      } catch (e) {
        console.error('[OKTA Callback] Error:', e);
        error_message.value = e.message || 'Authentication failed';
        error_code.value = e.errorCode || 'AUTH_ERROR';
        error.value = true;
      }
    });

    return {
      error_code,
      error_message,
      error,
    };
  },
};
</script>

<style scoped lang="css">
h1 {
  font-size: 70px;
  line-height: 150px;
  font-weight: 700;
  color: #fcc000;
}

.callback-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.5rem;
}
</style>
